import axios from "axios"
import {
	CreateLocationDetailsInterface,
	GetAllLocationDetailsInterface,
	GetLocationDetailsInterface,
	GetLocationStats,
	GetLocationTrends,
	LocationStats,
	LocationTrends,
} from "@type/locations.types"

const ROOT_PATH = "locations/details"
const ROOT_PATH_PARENT = "locations"

export default class LocationsService {
	static createLocation = (location: CreateLocationDetailsInterface) =>
		axios.post<GetLocationDetailsInterface>(ROOT_PATH, location)

	static getAllLocations = () => axios.get<GetLocationDetailsInterface[]>(`${ROOT_PATH}`)
	static getAllLocationsDetail = () => axios.get<GetAllLocationDetailsInterface[]>("locations")

	static getLocationByBranchId = (id: string, isActive = true) =>
		axios.get<GetLocationDetailsInterface[]>(`${ROOT_PATH}-by-branch`, {
			params: {
				branch: id,
				isActive,
			},
		})

	static getLocationDetailsById = (id: string) => axios.get<GetLocationDetailsInterface>(`${ROOT_PATH}/${id}`)

	static getLocationBySearch = (location: { name?: string; sin?: string }) =>
		axios.get<GetLocationDetailsInterface>(`${ROOT_PATH_PARENT}/enhanced-search`, { params: location })

	static updateLocationDetails = (locationId: string, location: Partial<GetLocationDetailsInterface>) =>
		axios.put<GetLocationDetailsInterface>(`${ROOT_PATH}/${locationId}`, location)

	static getLocationStats = (locations: GetLocationStats) =>
		axios.post<LocationStats>(`analytics/shift-stats`, locations)

	static getLocationTrends = (locations: GetLocationTrends) =>
		axios.post<LocationTrends>(`analytics/shift-trends`, locations)
}
